window.$ = require('jquery')
window.jQuery = require('jquery')
window._ = require('lodash')
window.enquire = require('enquire.js')
window.moment = require('moment/moment')
import 'moment/locale/ja'
import 'bootstrap'
